import getDisplayPropertiesForEmptyList from '../utils/getDisplayPropertiesForEmptyList';
import { observer } from 'mobx-react-lite';
import { getFocusedFilterForTable, listViewStore } from 'owa-mail-list-store';
import { AnswersContainer } from 'owa-mail-search';
import { MessageAdList } from 'owa-mail-messagead-list-view';
import { isReadingPanePositionBottom } from 'owa-mail-layout';
import { MailListViewState } from 'owa-mail-store/lib/store/schema/MailListViewState';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { GetStartedListInListView } from 'owa-getstarted';
import * as React from 'react';
import EmptyState, { EmptyStateProps } from 'owa-empty-state/lib/components/EmptyState';

const classNames = require('classnames');
const styles = require('./MailListEmptyState.scss');

export interface EmptyListViewProps {
    tableViewId: string;
    stateType: MailListViewState;
    clearFilterCommand: () => void;
    reloadCommand: () => void;
    shouldShowMessageAdList: boolean;
    shouldShowGetStartedList: boolean;
    shouldShowSearchAnswer: boolean;
    itemsPreviouslyLoaded: boolean;
}

const MailListEmptyState = observer(function MailListEmptyState(props: EmptyListViewProps) {
    const {
        tableViewId,
        stateType,
        clearFilterCommand,
        reloadCommand,
        shouldShowSearchAnswer,
    } = props;

    let emptyState: EmptyStateProps = {
        mainMessage: null,
        detailMessage: null,
        ctaMessage: null,
        onCtaClick: null,
        icon: null,
    };

    emptyState = getDisplayPropertiesForEmptyList(
        tableViewId,
        stateType,
        props.itemsPreviouslyLoaded,
        clearFilterCommand,
        reloadCommand
    );

    const messageContainerClassNames = classNames(
        styles.infoMessageContainer,
        isReadingPanePositionBottom() ? styles.isReadingPaneBottom : ''
    );

    const tableView = listViewStore.tableViews.get(tableViewId);

    // Only fire the native ad when the listview state is really empty. Sometimes, this is in the loading state.
    const needShowMessageAdList =
        props.shouldShowMessageAdList && props.stateType == MailListViewState.Empty;

    const needShowGetStartedList =
        props.shouldShowGetStartedList && props.stateType == MailListViewState.Empty;

    return (
        <div className={styles.mailListEmptyStateContainer}>
            {props.stateType !== MailListViewState.Loading && shouldShowSearchAnswer && (
                <AnswersContainer
                    tableQuery={tableView.tableQuery}
                    isRenderingInMailListEmptyState={true}
                />
            )}
            {(needShowMessageAdList || needShowGetStartedList) && (
                <div className={styles.adAndGetStartedContainer}>
                    {needShowMessageAdList && (
                        <div className={styles.adContainer}>
                            <MessageAdList
                                loadInOtherPivot={
                                    getFocusedFilterForTable(
                                        listViewStore.tableViews.get(tableViewId)
                                    ) == FocusedViewFilter.Other
                                }
                                loadInEmptyPivot={true}
                                loadInItemView={
                                    tableView.tableQuery.listViewType == ReactListViewType.Message
                                }
                            />
                        </div>
                    )}
                    {needShowGetStartedList && <GetStartedListInListView rowCount={0} />}
                </div>
            )}
            <EmptyState
                icon={emptyState.icon}
                mainMessage={emptyState.mainMessage}
                detailMessage={emptyState.detailMessage}
                ctaMessage={emptyState.ctaMessage}
                onCtaClick={emptyState.onCtaClick}
                classNames={{
                    container: messageContainerClassNames,
                }}
            />
        </div>
    );
});
export default MailListEmptyState;
